import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import LibraryPage from "./pages/LibraryPage";
import SeriesPage from "./pages/SeriesPage";
import ChapterPage from "./pages/ChapterPage";
import AboutPage from "./pages/AboutPage";
import SubscribePage from "./pages/SubscribePage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import AdminPage from "./pages/AdminPage";
import NewChaptersPage from "./pages/NewChaptersPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import MyLibraryPage from "./pages/MyLibraryPage";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-ff-bg">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="library" element={<LibraryPage />} />
              <Route path="my-library" element={<MyLibraryPage />} />
              <Route path="new" element={<NewChaptersPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="subscribe" element={<SubscribePage />} />
              <Route path="terms" element={<TermsPage />} />
              <Route path="privacy" element={<PrivacyPage />} />
              <Route path="payment/success" element={<PaymentSuccessPage />} />
              <Route path=":seriesSlug" element={<SeriesPage />} />
              <Route path=":seriesSlug/:chapterSlug" element={<ChapterPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
